import React, { useMemo } from "react";
import { Alert } from "antd";
import { useTranslation } from "react-i18next";
import {
  getAllowedPromptTokenSetForMetric,
  listUnknownPromptBraceTokens,
} from "./promptVariables";
import styles from "./style.module.scss";

/**
 * Read-only check: tokens matching `{…}` that are not in the metric variable list
 * (plus known worker aliases). Plain textarea is unchanged — no overlay.
 */
export function PromptUnknownTokensNote({ metricId, text }) {
  const { t } = useTranslation();

  const unknown = useMemo(() => {
    const allowed = getAllowedPromptTokenSetForMetric(metricId);
    return listUnknownPromptBraceTokens(text, allowed);
  }, [metricId, text]);

  if (!unknown.length) {
    return null;
  }

  return (
    <Alert
      type="warning"
      showIcon
      className={styles.promptUnknownTokensNote}
      message={
        <>
          <span className={styles.promptUnknownTokensLead}>
            {t("welcome.promptUnknownTokensLead")}
          </span>
          <span className={styles.promptUnknownTokensList}>
            {unknown.map((tok) => (
              <code key={tok} className={styles.promptUnknownTokenChip}>
                {tok}
              </code>
            ))}
          </span>
        </>
      }
    />
  );
}
